'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
const defaults = {
  id: null,
  // Used for ListTransition
  dayOfWeek: '',
  startTime: null,
  endTime: null
};
export default class BusinessHour extends Immutable.Record(defaults) {
  constructor(values) {
    super(Object.assign({}, cleanObject(values), {
      id: uniqueId('business-hour-')
    }));
  } // 'id' is used as a unique key that persists as the record updates, for ListTransition


  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }

}